import {Grid, Loader} from '@yandex-delivery/blocks'
import {useFormContext} from '@yandex-delivery/form'
import {Select} from '@yandex-delivery/nlf-form/v2'
import React from 'react'

import type {DeliveryInterval, Props} from './type'

export function DeliveryIntervals(props: Props): React.ReactElement<Props> {
  const {direction, name, dates, intervals, isLoading = false, placeholders} = props
  const {watch} = useFormContext()

  const deliveryDateValue = watch(`${name}.deliveryDate`)

  return (
    <Grid direction={direction} size="s" container>
      <Grid item xs>
        <Select<string>
          name={`${name}.deliveryDate`}
          options={dates}
          placeholder={placeholders?.date}
          trail={isLoading && <Loader />}
          shouldUnregister
        />
      </Grid>
      <Grid key={deliveryDateValue} item xs>
        <Select<DeliveryInterval>
          name={`${name}.deliveryInterval`}
          options={intervals}
          placeholder={placeholders?.interval}
          trail={isLoading && <Loader />}
          shouldUnregister
        />
      </Grid>
    </Grid>
  )
}
